/* tslint:disable */
/* eslint-disable */
/**
 * PGA Pool API
 * The API for PGA Pool
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * @type BooleanFieldFilter
 * @export
 */
export type BooleanFieldFilter = BooleanFilterOps | boolean;

/**
 * 
 * @export
 * @interface BooleanFilterOps
 */
export interface BooleanFilterOps {
    /**
     * 
     * @type {boolean}
     * @memberof BooleanFilterOps
     */
    'eq'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BooleanFilterOps
     */
    'neq'?: boolean;
}
/**
 * 
 * @export
 * @interface GetPool404Response
 */
export interface GetPool404Response {
    /**
     * The HTTP status code
     * @type {number}
     * @memberof GetPool404Response
     */
    'status': number;
    /**
     * The error response code
     * @type {string}
     * @memberof GetPool404Response
     */
    'message': string;
    /**
     * Additional detail about the error
     * @type {string}
     * @memberof GetPool404Response
     */
    'detail': string | null;
}
/**
 * 
 * @export
 * @interface LimitOffsetResponseMeta
 */
export interface LimitOffsetResponseMeta {
    /**
     * 
     * @type {LimitOffsetResponseMetaPage}
     * @memberof LimitOffsetResponseMeta
     */
    'page': LimitOffsetResponseMetaPage;
}
/**
 * 
 * @export
 * @interface LimitOffsetResponseMetaPage
 */
export interface LimitOffsetResponseMetaPage {
    /**
     * Requested page size.
     * @type {number}
     * @memberof LimitOffsetResponseMetaPage
     */
    'requested_size': number;
    /**
     * Specifies the actual size of the page returned.
     * @type {number}
     * @memberof LimitOffsetResponseMetaPage
     */
    'actual_size': number;
    /**
     * Specifies the current page number (1-based index).
     * @type {number}
     * @memberof LimitOffsetResponseMetaPage
     */
    'number': number;
    /**
     * Total amount of items.
     * @type {number}
     * @memberof LimitOffsetResponseMetaPage
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface ListPgaPlayers200Response
 */
export interface ListPgaPlayers200Response {
    /**
     * 
     * @type {LimitOffsetResponseMeta}
     * @memberof ListPgaPlayers200Response
     */
    'meta': LimitOffsetResponseMeta;
    /**
     * 
     * @type {Array<PgaPlayer>}
     * @memberof ListPgaPlayers200Response
     */
    'data': Array<PgaPlayer>;
}
/**
 * 
 * @export
 * @interface ListPgaPlayersFilterParameter
 */
export interface ListPgaPlayersFilterParameter {
    /**
     * Case-insensitive partial match on player name
     * @type {string}
     * @memberof ListPgaPlayersFilterParameter
     */
    'name'?: string;
    /**
     * Filter by active status (defaults to true if not specified)
     * @type {boolean}
     * @memberof ListPgaPlayersFilterParameter
     */
    'active'?: boolean;
}
/**
 * 
 * @export
 * @interface ListPgaTournamentPlayers200Response
 */
export interface ListPgaTournamentPlayers200Response {
    /**
     * 
     * @type {LimitOffsetResponseMeta}
     * @memberof ListPgaTournamentPlayers200Response
     */
    'meta': LimitOffsetResponseMeta;
    /**
     * 
     * @type {Array<PgaTournamentPlayer>}
     * @memberof ListPgaTournamentPlayers200Response
     */
    'data': Array<PgaTournamentPlayer>;
}
/**
 * 
 * @export
 * @interface ListPgaTournaments200Response
 */
export interface ListPgaTournaments200Response {
    /**
     * 
     * @type {LimitOffsetResponseMeta}
     * @memberof ListPgaTournaments200Response
     */
    'meta': LimitOffsetResponseMeta;
    /**
     * 
     * @type {Array<PgaTournament>}
     * @memberof ListPgaTournaments200Response
     */
    'data': Array<PgaTournament>;
}
/**
 * 
 * @export
 * @interface ListPoolTournamentPlayers200Response
 */
export interface ListPoolTournamentPlayers200Response {
    /**
     * 
     * @type {LimitOffsetResponseMeta}
     * @memberof ListPoolTournamentPlayers200Response
     */
    'meta': LimitOffsetResponseMeta;
    /**
     * 
     * @type {Array<PoolTournamentPlayer>}
     * @memberof ListPoolTournamentPlayers200Response
     */
    'data': Array<PoolTournamentPlayer>;
}
/**
 * 
 * @export
 * @interface ListPoolTournamentPlayersFilterParameter
 */
export interface ListPoolTournamentPlayersFilterParameter {
    /**
     * 
     * @type {NumberFieldFilter}
     * @memberof ListPoolTournamentPlayersFilterParameter
     */
    'tier'?: NumberFieldFilter;
    /**
     * 
     * @type {NumberFieldFilter}
     * @memberof ListPoolTournamentPlayersFilterParameter
     */
    'pga_player_id'?: NumberFieldFilter;
    /**
     * 
     * @type {StringEqNeqFieldFilter}
     * @memberof ListPoolTournamentPlayersFilterParameter
     */
    'status'?: StringEqNeqFieldFilter;
    /**
     * 
     * @type {BooleanFieldFilter}
     * @memberof ListPoolTournamentPlayersFilterParameter
     */
    'active'?: BooleanFieldFilter;
}
/**
 * 
 * @export
 * @interface ListPoolTournamentUsers200Response
 */
export interface ListPoolTournamentUsers200Response {
    /**
     * 
     * @type {LimitOffsetResponseMeta}
     * @memberof ListPoolTournamentUsers200Response
     */
    'meta': LimitOffsetResponseMeta;
    /**
     * 
     * @type {Array<PoolTournamentUser>}
     * @memberof ListPoolTournamentUsers200Response
     */
    'data': Array<PoolTournamentUser>;
}
/**
 * 
 * @export
 * @interface ListPoolTournaments200Response
 */
export interface ListPoolTournaments200Response {
    /**
     * 
     * @type {Array<PoolTournament>}
     * @memberof ListPoolTournaments200Response
     */
    'data': Array<PoolTournament>;
}
/**
 * 
 * @export
 * @interface ListPoolTournamentsFilterParameter
 */
export interface ListPoolTournamentsFilterParameter {
    /**
     * 
     * @type {StringFieldFilter}
     * @memberof ListPoolTournamentsFilterParameter
     */
    'name'?: StringFieldFilter;
    /**
     * 
     * @type {NumberFieldFilter}
     * @memberof ListPoolTournamentsFilterParameter
     */
    'date.year'?: NumberFieldFilter;
    /**
     * 
     * @type {TimestampFilterOps}
     * @memberof ListPoolTournamentsFilterParameter
     */
    'date.start'?: TimestampFilterOps;
    /**
     * 
     * @type {TimestampFilterOps}
     * @memberof ListPoolTournamentsFilterParameter
     */
    'date.end'?: TimestampFilterOps;
    /**
     * 
     * @type {BooleanFieldFilter}
     * @memberof ListPoolTournamentsFilterParameter
     */
    'fedex_cup_event'?: BooleanFieldFilter;
    /**
     * 
     * @type {StringEqNeqFieldFilter}
     * @memberof ListPoolTournamentsFilterParameter
     */
    'scoring_format'?: StringEqNeqFieldFilter;
    /**
     * 
     * @type {StringEqNeqFieldFilter}
     * @memberof ListPoolTournamentsFilterParameter
     */
    'tournament_status'?: StringEqNeqFieldFilter;
}
/**
 * 
 * @export
 * @interface ListPoolUsers200Response
 */
export interface ListPoolUsers200Response {
    /**
     * 
     * @type {LimitOffsetResponseMeta}
     * @memberof ListPoolUsers200Response
     */
    'meta': LimitOffsetResponseMeta;
    /**
     * 
     * @type {Array<PoolUser>}
     * @memberof ListPoolUsers200Response
     */
    'data': Array<PoolUser>;
}
/**
 * 
 * @export
 * @interface ListPoolUsersFilterParameter
 */
export interface ListPoolUsersFilterParameter {
    /**
     * 
     * @type {StringEqNeqFieldFilter}
     * @memberof ListPoolUsersFilterParameter
     */
    'user.id'?: StringEqNeqFieldFilter;
    /**
     * 
     * @type {StringFieldFilter}
     * @memberof ListPoolUsersFilterParameter
     */
    'user.name'?: StringFieldFilter;
    /**
     * 
     * @type {StringFieldFilter}
     * @memberof ListPoolUsersFilterParameter
     */
    'user.nickname'?: StringFieldFilter;
    /**
     * 
     * @type {NumberFieldFilter}
     * @memberof ListPoolUsersFilterParameter
     */
    'pool_score'?: NumberFieldFilter;
}
/**
 * 
 * @export
 * @interface ListPools200Response
 */
export interface ListPools200Response {
    /**
     * 
     * @type {LimitOffsetResponseMeta}
     * @memberof ListPools200Response
     */
    'meta': LimitOffsetResponseMeta;
    /**
     * 
     * @type {Array<Pool>}
     * @memberof ListPools200Response
     */
    'data': Array<Pool>;
}
/**
 * 
 * @export
 * @interface ListPoolsFilterParameter
 */
export interface ListPoolsFilterParameter {
    /**
     * 
     * @type {NumberFieldFilter}
     * @memberof ListPoolsFilterParameter
     */
    'year'?: NumberFieldFilter;
    /**
     * 
     * @type {StringEqNeqFieldFilter}
     * @memberof ListPoolsFilterParameter
     */
    'type'?: StringEqNeqFieldFilter;
    /**
     * 
     * @type {StringFieldFilter}
     * @memberof ListPoolsFilterParameter
     */
    'name'?: StringFieldFilter;
}
/**
 * 
 * @export
 * @interface ListPoolsPageParameter
 */
export interface ListPoolsPageParameter {
    /**
     * The number of items included per page.
     * @type {number}
     * @memberof ListPoolsPageParameter
     */
    'size'?: number;
    /**
     * The specific page number (1-based) of the collection results.
     * @type {number}
     * @memberof ListPoolsPageParameter
     */
    'number'?: number;
}
/**
 * @type NumberFieldFilter
 * @export
 */
export type NumberFieldFilter = NumberFilterOps | number;

/**
 * 
 * @export
 * @interface NumberFilterOps
 */
export interface NumberFilterOps {
    /**
     * 
     * @type {number}
     * @memberof NumberFilterOps
     */
    'eq'?: number;
    /**
     * 
     * @type {number}
     * @memberof NumberFilterOps
     */
    'neq'?: number;
    /**
     * 
     * @type {number}
     * @memberof NumberFilterOps
     */
    'gt'?: number;
    /**
     * 
     * @type {number}
     * @memberof NumberFilterOps
     */
    'gte'?: number;
    /**
     * 
     * @type {number}
     * @memberof NumberFilterOps
     */
    'lt'?: number;
    /**
     * 
     * @type {number}
     * @memberof NumberFilterOps
     */
    'lte'?: number;
}
/**
 * Defines a PGA player (i.e. golfer)
 * @export
 * @interface PgaPlayer
 */
export interface PgaPlayer {
    /**
     * 
     * @type {number}
     * @memberof PgaPlayer
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof PgaPlayer
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PgaPlayer
     */
    'short_name': string;
    /**
     * 
     * @type {string}
     * @memberof PgaPlayer
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof PgaPlayer
     */
    'last_name': string;
    /**
     * 
     * @type {boolean}
     * @memberof PgaPlayer
     */
    'active': boolean;
    /**
     * 
     * @type {string}
     * @memberof PgaPlayer
     */
    'headshot_url': string | null;
    /**
     * 
     * @type {string}
     * @memberof PgaPlayer
     */
    'country': string | null;
    /**
     * 
     * @type {string}
     * @memberof PgaPlayer
     */
    'country_flag': string | null;
    /**
     * 
     * @type {string}
     * @memberof PgaPlayer
     */
    'country_flag_url': string | null;
}
/**
 * Defines a PGA tournament event
 * @export
 * @interface PgaTournament
 */
export interface PgaTournament {
    /**
     * ID in the format of \"{tournamentId}-{year}\"
     * @type {string}
     * @memberof PgaTournament
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PgaTournament
     */
    'name': string;
    /**
     * 
     * @type {TournamentDate}
     * @memberof PgaTournament
     */
    'date': TournamentDate;
    /**
     * 
     * @type {number}
     * @memberof PgaTournament
     */
    'purse': number;
    /**
     * 
     * @type {number}
     * @memberof PgaTournament
     */
    'fedex_cup_points': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof PgaTournament
     */
    'fedex_cup_event': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PgaTournament
     */
    'official_fedex_cup_points_calculated': boolean;
    /**
     * 
     * @type {string}
     * @memberof PgaTournament
     */
    'scoring_format': PgaTournamentScoringFormatEnum;
    /**
     * 
     * @type {string}
     * @memberof PgaTournament
     */
    'tournament_status': PgaTournamentTournamentStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PgaTournament
     */
    'round_status': PgaTournamentRoundStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof PgaTournament
     */
    'current_round': number | null;
    /**
     * 
     * @type {string}
     * @memberof PgaTournament
     */
    'course_name': string;
    /**
     * 
     * @type {string}
     * @memberof PgaTournament
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof PgaTournament
     */
    'country_code': string;
    /**
     * 
     * @type {string}
     * @memberof PgaTournament
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof PgaTournament
     */
    'state_code': string;
    /**
     * 
     * @type {string}
     * @memberof PgaTournament
     */
    'city': string;
    /**
     * 
     * @type {PgaTournamentPreviousChampion}
     * @memberof PgaTournament
     */
    'previous_champion': PgaTournamentPreviousChampion;
    /**
     * 
     * @type {string}
     * @memberof PgaTournament
     */
    'logo_url': string | null;
    /**
     * 
     * @type {string}
     * @memberof PgaTournament
     */
    'course_image_url': string | null;
    /**
     * Total par for the course (e.g. 72)
     * @type {number}
     * @memberof PgaTournament
     */
    'par': number | null;
    /**
     * Total course yardage (e.g. 7392)
     * @type {number}
     * @memberof PgaTournament
     */
    'yardage': number | null;
}

export const PgaTournamentScoringFormatEnum = {
    StrokePlay: 'STROKE_PLAY',
    TeamStroke: 'TEAM_STROKE',
    Stableford: 'STABLEFORD'
} as const;

export type PgaTournamentScoringFormatEnum = typeof PgaTournamentScoringFormatEnum[keyof typeof PgaTournamentScoringFormatEnum];
export const PgaTournamentTournamentStatusEnum = {
    NotStarted: 'NOT_STARTED',
    InProgress: 'IN_PROGRESS',
    Completed: 'COMPLETED'
} as const;

export type PgaTournamentTournamentStatusEnum = typeof PgaTournamentTournamentStatusEnum[keyof typeof PgaTournamentTournamentStatusEnum];
export const PgaTournamentRoundStatusEnum = {
    Upcoming: 'UPCOMING',
    GroupingsOfficial: 'GROUPINGS_OFFICIAL',
    InProgress: 'IN_PROGRESS',
    Suspended: 'SUSPENDED',
    Complete: 'COMPLETE',
    Official: 'OFFICIAL'
} as const;

export type PgaTournamentRoundStatusEnum = typeof PgaTournamentRoundStatusEnum[keyof typeof PgaTournamentRoundStatusEnum];

/**
 * The PGA Tournament player field as a flat list of players.
 * @export
 * @interface PgaTournamentField
 */
export interface PgaTournamentField {
    /**
     * 
     * @type {PgaTournament}
     * @memberof PgaTournamentField
     */
    'pga_tournament': PgaTournament;
    /**
     * 
     * @type {Array<TournamentFieldPlayer>}
     * @memberof PgaTournamentField
     */
    'players': Array<TournamentFieldPlayer>;
}
/**
 * Defines a PGA player participating in a PGA tournament
 * @export
 * @interface PgaTournamentPlayer
 */
export interface PgaTournamentPlayer {
    /**
     * ID in the format of {pgaPlayerId}-{pgaTournamentId}
     * @type {string}
     * @memberof PgaTournamentPlayer
     */
    'id': string;
    /**
     * 
     * @type {boolean}
     * @memberof PgaTournamentPlayer
     */
    'active': boolean;
    /**
     * 
     * @type {string}
     * @memberof PgaTournamentPlayer
     */
    'status': PgaTournamentPlayerStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof PgaTournamentPlayer
     */
    'is_round_complete': boolean;
    /**
     * 
     * @type {number}
     * @memberof PgaTournamentPlayer
     */
    'current_round': number | null;
    /**
     * 
     * @type {number}
     * @memberof PgaTournamentPlayer
     */
    'current_hole': number;
    /**
     * 
     * @type {number}
     * @memberof PgaTournamentPlayer
     */
    'starting_hole': number;
    /**
     * 
     * @type {string}
     * @memberof PgaTournamentPlayer
     */
    'tee_time': string | null;
    /**
     * 
     * @type {number}
     * @memberof PgaTournamentPlayer
     */
    'score_total': number;
    /**
     * 
     * @type {number}
     * @memberof PgaTournamentPlayer
     */
    'score_thru': number | null;
    /**
     * 
     * @type {string}
     * @memberof PgaTournamentPlayer
     */
    'current_position': string | null;
    /**
     * 
     * @type {number}
     * @memberof PgaTournamentPlayer
     */
    'projected_fedex_cup_points'?: number;
    /**
     * 
     * @type {number}
     * @memberof PgaTournamentPlayer
     */
    'official_fedex_cup_points'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof PgaTournamentPlayer
     */
    'withdrawn': boolean;
    /**
     * 
     * @type {Array<RoundSummary>}
     * @memberof PgaTournamentPlayer
     */
    'rounds': Array<RoundSummary>;
    /**
     * 
     * @type {PgaPlayer}
     * @memberof PgaTournamentPlayer
     */
    'pga_player': PgaPlayer;
    /**
     * 
     * @type {PgaTournament}
     * @memberof PgaTournamentPlayer
     */
    'pga_tournament': PgaTournament;
}

export const PgaTournamentPlayerStatusEnum = {
    Active: 'active',
    Complete: 'complete',
    Wd: 'wd',
    Cut: 'cut'
} as const;

export type PgaTournamentPlayerStatusEnum = typeof PgaTournamentPlayerStatusEnum[keyof typeof PgaTournamentPlayerStatusEnum];

/**
 * 
 * @export
 * @interface PgaTournamentPreviousChampion
 */
export interface PgaTournamentPreviousChampion {
    /**
     * 
     * @type {number}
     * @memberof PgaTournamentPreviousChampion
     */
    'id': number | null;
    /**
     * 
     * @type {string}
     * @memberof PgaTournamentPreviousChampion
     */
    'name': string | null;
}
/**
 * Defines a pool
 * @export
 * @interface Pool
 */
export interface Pool {
    /**
     * 
     * @type {string}
     * @memberof Pool
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof Pool
     */
    'year': number;
    /**
     * 
     * @type {string}
     * @memberof Pool
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Pool
     */
    'type': PoolTypeEnum;
    /**
     * 
     * @type {PoolSettings}
     * @memberof Pool
     */
    'settings': PoolSettings;
    /**
     * 
     * @type {string}
     * @memberof Pool
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof Pool
     */
    'updated_at': string;
}

export const PoolTypeEnum = {
    SingleTournament: 'single_tournament',
    Season: 'season'
} as const;

export type PoolTypeEnum = typeof PoolTypeEnum[keyof typeof PoolTypeEnum];

/**
 * Pool configuration settings
 * @export
 * @interface PoolSettings
 */
export interface PoolSettings {
    /**
     * 
     * @type {string}
     * @memberof PoolSettings
     */
    'scoring_format': PoolSettingsScoringFormatEnum;
    /**
     * 
     * @type {boolean}
     * @memberof PoolSettings
     */
    'include_LIV'?: boolean | null;
}

export const PoolSettingsScoringFormatEnum = {
    Strokes: 'strokes',
    FedexCupPoints: 'fedex_cup_points'
} as const;

export type PoolSettingsScoringFormatEnum = typeof PoolSettingsScoringFormatEnum[keyof typeof PoolSettingsScoringFormatEnum];

/**
 * Defines a pool tournament
 * @export
 * @interface PoolTournament
 */
export interface PoolTournament {
    /**
     * 
     * @type {string}
     * @memberof PoolTournament
     */
    'id': string;
    /**
     * 
     * @type {boolean}
     * @memberof PoolTournament
     */
    'scores_are_official': boolean;
    /**
     * 
     * @type {PgaTournament}
     * @memberof PoolTournament
     */
    'pga_tournament': PgaTournament;
    /**
     * 
     * @type {Pool}
     * @memberof PoolTournament
     */
    'pool': Pool;
}
/**
 * The pool tournament player field divided into tiers.
 * @export
 * @interface PoolTournamentField
 */
export interface PoolTournamentField {
    /**
     * 
     * @type {PoolTournament}
     * @memberof PoolTournamentField
     */
    'pool_tournament': PoolTournament;
    /**
     * 
     * @type {string}
     * @memberof PoolTournamentField
     */
    'created_at': string | null;
    /**
     * 
     * @type {{ [key: string]: Array<PoolTournamentPlayer>; }}
     * @memberof PoolTournamentField
     */
    'player_tiers': { [key: string]: Array<PoolTournamentPlayer>; };
}
/**
 * Defines a pool tournament player
 * @export
 * @interface PoolTournamentPlayer
 */
export interface PoolTournamentPlayer {
    /**
     * 
     * @type {string}
     * @memberof PoolTournamentPlayer
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof PoolTournamentPlayer
     */
    'tier': number;
    /**
     * 
     * @type {string}
     * @memberof PoolTournamentPlayer
     */
    'odds': string | null;
    /**
     * 
     * @type {PgaTournamentPlayer}
     * @memberof PoolTournamentPlayer
     */
    'pga_tournament_player': PgaTournamentPlayer;
}
/**
 * Defines a pool tournament user
 * @export
 * @interface PoolTournamentUser
 */
export interface PoolTournamentUser {
    /**
     * 
     * @type {string}
     * @memberof PoolTournamentUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PoolTournamentUser
     */
    'rank': string;
    /**
     * 
     * @type {number}
     * @memberof PoolTournamentUser
     */
    'score': number | null;
    /**
     * 
     * @type {number}
     * @memberof PoolTournamentUser
     */
    'fedex_cup_points': number | null;
    /**
     * 
     * @type {User}
     * @memberof PoolTournamentUser
     */
    'user': User;
    /**
     * 
     * @type {Array<PoolTournamentUserPick>}
     * @memberof PoolTournamentUser
     */
    'picks': Array<PoolTournamentUserPick>;
}
/**
 * Defines a pool tournament user pick
 * @export
 * @interface PoolTournamentUserPick
 */
export interface PoolTournamentUserPick {
    /**
     * 
     * @type {number}
     * @memberof PoolTournamentUserPick
     */
    'tier': number;
    /**
     * Field-snapshot odds from pool field generation
     * @type {string}
     * @memberof PoolTournamentUserPick
     */
    'odds': string | null;
    /**
     * 
     * @type {PgaTournamentPlayer}
     * @memberof PoolTournamentUserPick
     */
    'pga_tournament_player': PgaTournamentPlayer;
}
/**
 * Defines a pool user
 * @export
 * @interface PoolUser
 */
export interface PoolUser {
    /**
     * 
     * @type {string}
     * @memberof PoolUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PoolUser
     */
    'pool_id': string;
    /**
     * 
     * @type {number}
     * @memberof PoolUser
     */
    'pool_score': number;
    /**
     * 
     * @type {User}
     * @memberof PoolUser
     */
    'user': User;
    /**
     * 
     * @type {string}
     * @memberof PoolUser
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof PoolUser
     */
    'updated_at': string;
}
/**
 * Per-round score summary for a PGA tournament player
 * @export
 * @interface RoundSummary
 */
export interface RoundSummary {
    /**
     * 
     * @type {number}
     * @memberof RoundSummary
     */
    'round_number': number;
    /**
     * 
     * @type {number}
     * @memberof RoundSummary
     */
    'strokes': number;
    /**
     * 
     * @type {number}
     * @memberof RoundSummary
     */
    'to_par': number;
}
/**
 * Hole-by-hole scorecard for a specific round
 * @export
 * @interface Scorecard
 */
export interface Scorecard {
    /**
     * 
     * @type {number}
     * @memberof Scorecard
     */
    'round_number': number;
    /**
     * 
     * @type {number}
     * @memberof Scorecard
     */
    'strokes': number;
    /**
     * 
     * @type {number}
     * @memberof Scorecard
     */
    'to_par': number;
    /**
     * 
     * @type {Array<ScorecardHole>}
     * @memberof Scorecard
     */
    'holes': Array<ScorecardHole>;
}
/**
 * Individual hole score within a scorecard
 * @export
 * @interface ScorecardHole
 */
export interface ScorecardHole {
    /**
     * 
     * @type {number}
     * @memberof ScorecardHole
     */
    'hole_number': number;
    /**
     * 
     * @type {number}
     * @memberof ScorecardHole
     */
    'par': number;
    /**
     * 
     * @type {number}
     * @memberof ScorecardHole
     */
    'score': number;
    /**
     * 
     * @type {number}
     * @memberof ScorecardHole
     */
    'to_par': number;
    /**
     * 
     * @type {string}
     * @memberof ScorecardHole
     */
    'status': ScorecardHoleStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof ScorecardHole
     */
    'yardage': number;
}

export const ScorecardHoleStatusEnum = {
    Birdie: 'birdie',
    Bogey: 'bogey',
    Eagle: 'eagle',
    DoubleBogey: 'double_bogey',
    Par: 'par',
    None: 'none'
} as const;

export type ScorecardHoleStatusEnum = typeof ScorecardHoleStatusEnum[keyof typeof ScorecardHoleStatusEnum];

/**
 * @type StringEqNeqFieldFilter
 * @export
 */
export type StringEqNeqFieldFilter = StringEqNeqFilterOps | string;

/**
 * 
 * @export
 * @interface StringEqNeqFilterOps
 */
export interface StringEqNeqFilterOps {
    /**
     * 
     * @type {string}
     * @memberof StringEqNeqFilterOps
     */
    'eq'?: string;
    /**
     * 
     * @type {string}
     * @memberof StringEqNeqFilterOps
     */
    'neq'?: string;
}
/**
 * @type StringFieldFilter
 * @export
 */
export type StringFieldFilter = StringFilterOps | string;

/**
 * 
 * @export
 * @interface StringFilterOps
 */
export interface StringFilterOps {
    /**
     * 
     * @type {string}
     * @memberof StringFilterOps
     */
    'eq'?: string;
    /**
     * 
     * @type {string}
     * @memberof StringFilterOps
     */
    'neq'?: string;
    /**
     * 
     * @type {string}
     * @memberof StringFilterOps
     */
    'contains'?: string;
}
/**
 * 
 * @export
 * @interface TimestampFilterOps
 */
export interface TimestampFilterOps {
    /**
     * 
     * @type {string}
     * @memberof TimestampFilterOps
     */
    'gt'?: string;
    /**
     * 
     * @type {string}
     * @memberof TimestampFilterOps
     */
    'gte'?: string;
    /**
     * 
     * @type {string}
     * @memberof TimestampFilterOps
     */
    'lt'?: string;
    /**
     * 
     * @type {string}
     * @memberof TimestampFilterOps
     */
    'lte'?: string;
}
/**
 * Defines a tournament date
 * @export
 * @interface TournamentDate
 */
export interface TournamentDate {
    /**
     * 
     * @type {number}
     * @memberof TournamentDate
     */
    'year': number;
    /**
     * 
     * @type {string}
     * @memberof TournamentDate
     */
    'start': string;
    /**
     * 
     * @type {string}
     * @memberof TournamentDate
     */
    'end': string;
    /**
     * 
     * @type {string}
     * @memberof TournamentDate
     */
    'timezone': string;
    /**
     * 
     * @type {string}
     * @memberof TournamentDate
     */
    'display': string;
    /**
     * 
     * @type {string}
     * @memberof TournamentDate
     */
    'display_short': string;
}
/**
 * Defines a player entry in a tournament field.
 * @export
 * @interface TournamentFieldPlayer
 */
export interface TournamentFieldPlayer {
    /**
     * 
     * @type {number}
     * @memberof TournamentFieldPlayer
     */
    'player_id': number;
    /**
     * 
     * @type {string}
     * @memberof TournamentFieldPlayer
     */
    'name': string;
}
/**
 * Defines a user (i.e. contestant who competes in pools)
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'nickname': string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'email': string | null;
}
/**
 * The PGA Tournament player field for the current week.
 * @export
 * @interface WeeklyPgaTournamentField
 */
export interface WeeklyPgaTournamentField {
    /**
     * 
     * @type {PgaTournament}
     * @memberof WeeklyPgaTournamentField
     */
    'pga_tournament': PgaTournament;
    /**
     * 
     * @type {Array<TournamentFieldPlayer>}
     * @memberof WeeklyPgaTournamentField
     */
    'players': Array<TournamentFieldPlayer> | null;
}

/**
 * PGAPlayersApi - axios parameter creator
 * @export
 */
export const PGAPlayersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Fetches a PGA Player by ID
         * @summary Fetches a PGA Player by ID
         * @param {number} pgaPlayerId The PGA Player ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPgaPlayer: async (pgaPlayerId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pgaPlayerId' is not null or undefined
            assertParamExists('getPgaPlayer', 'pgaPlayerId', pgaPlayerId)
            const localVarPath = `/pga-players/{pgaPlayerId}`
                .replace(`{${"pgaPlayerId"}}`, encodeURIComponent(String(pgaPlayerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists PGA Players. Returns only active players by default.
         * @summary Lists PGA Players
         * @param {ListPoolsPageParameter} [page] 
         * @param {ListPgaPlayersFilterParameter} [filter] Filters a collection of PGA Players.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPgaPlayers: async (page?: ListPoolsPageParameter, filter?: ListPgaPlayersFilterParameter, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/pga-players`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PGAPlayersApi - functional programming interface
 * @export
 */
export const PGAPlayersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PGAPlayersApiAxiosParamCreator(configuration)
    return {
        /**
         * Fetches a PGA Player by ID
         * @summary Fetches a PGA Player by ID
         * @param {number} pgaPlayerId The PGA Player ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPgaPlayer(pgaPlayerId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PgaPlayer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPgaPlayer(pgaPlayerId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PGAPlayersApi.getPgaPlayer']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Lists PGA Players. Returns only active players by default.
         * @summary Lists PGA Players
         * @param {ListPoolsPageParameter} [page] 
         * @param {ListPgaPlayersFilterParameter} [filter] Filters a collection of PGA Players.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPgaPlayers(page?: ListPoolsPageParameter, filter?: ListPgaPlayersFilterParameter, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListPgaPlayers200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPgaPlayers(page, filter, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PGAPlayersApi.listPgaPlayers']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * PGAPlayersApi - factory interface
 * @export
 */
export const PGAPlayersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PGAPlayersApiFp(configuration)
    return {
        /**
         * Fetches a PGA Player by ID
         * @summary Fetches a PGA Player by ID
         * @param {PGAPlayersApiGetPgaPlayerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPgaPlayer(requestParameters: PGAPlayersApiGetPgaPlayerRequest, options?: RawAxiosRequestConfig): AxiosPromise<PgaPlayer> {
            return localVarFp.getPgaPlayer(requestParameters.pgaPlayerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists PGA Players. Returns only active players by default.
         * @summary Lists PGA Players
         * @param {PGAPlayersApiListPgaPlayersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPgaPlayers(requestParameters: PGAPlayersApiListPgaPlayersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListPgaPlayers200Response> {
            return localVarFp.listPgaPlayers(requestParameters.page, requestParameters.filter, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getPgaPlayer operation in PGAPlayersApi.
 * @export
 * @interface PGAPlayersApiGetPgaPlayerRequest
 */
export interface PGAPlayersApiGetPgaPlayerRequest {
    /**
     * The PGA Player ID
     * @type {number}
     * @memberof PGAPlayersApiGetPgaPlayer
     */
    readonly pgaPlayerId: number
}

/**
 * Request parameters for listPgaPlayers operation in PGAPlayersApi.
 * @export
 * @interface PGAPlayersApiListPgaPlayersRequest
 */
export interface PGAPlayersApiListPgaPlayersRequest {
    /**
     * 
     * @type {ListPoolsPageParameter}
     * @memberof PGAPlayersApiListPgaPlayers
     */
    readonly page?: ListPoolsPageParameter

    /**
     * Filters a collection of PGA Players.
     * @type {ListPgaPlayersFilterParameter}
     * @memberof PGAPlayersApiListPgaPlayers
     */
    readonly filter?: ListPgaPlayersFilterParameter
}

/**
 * PGAPlayersApi - object-oriented interface
 * @export
 * @class PGAPlayersApi
 * @extends {BaseAPI}
 */
export class PGAPlayersApi extends BaseAPI {
    /**
     * Fetches a PGA Player by ID
     * @summary Fetches a PGA Player by ID
     * @param {PGAPlayersApiGetPgaPlayerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PGAPlayersApi
     */
    public getPgaPlayer(requestParameters: PGAPlayersApiGetPgaPlayerRequest, options?: RawAxiosRequestConfig) {
        return PGAPlayersApiFp(this.configuration).getPgaPlayer(requestParameters.pgaPlayerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists PGA Players. Returns only active players by default.
     * @summary Lists PGA Players
     * @param {PGAPlayersApiListPgaPlayersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PGAPlayersApi
     */
    public listPgaPlayers(requestParameters: PGAPlayersApiListPgaPlayersRequest = {}, options?: RawAxiosRequestConfig) {
        return PGAPlayersApiFp(this.configuration).listPgaPlayers(requestParameters.page, requestParameters.filter, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PGATournamentFieldApi - axios parameter creator
 * @export
 */
export const PGATournamentFieldApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Fetches the tiered player field for a given PGA Tournament
         * @summary Fetches the player field for a given PGA Tournament
         * @param {string} pgaTournamentId The PGA Tournament ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getField: async (pgaTournamentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pgaTournamentId' is not null or undefined
            assertParamExists('getField', 'pgaTournamentId', pgaTournamentId)
            const localVarPath = `/pga-tournaments/{pgaTournamentId}/field`
                .replace(`{${"pgaTournamentId"}}`, encodeURIComponent(String(pgaTournamentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the tournament field for the current week (Sunday 2AM EST to Sunday 2AM EST). Returns 404 if no tournament is scheduled this week. Returns 200 with player_tiers: null if tournament exists but field data is not yet available. 
         * @summary Fetches the player field for the current week\'s tournament
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWeeklyField: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/pga-tournaments/weekly-field`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PGATournamentFieldApi - functional programming interface
 * @export
 */
export const PGATournamentFieldApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PGATournamentFieldApiAxiosParamCreator(configuration)
    return {
        /**
         * Fetches the tiered player field for a given PGA Tournament
         * @summary Fetches the player field for a given PGA Tournament
         * @param {string} pgaTournamentId The PGA Tournament ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getField(pgaTournamentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PgaTournamentField>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getField(pgaTournamentId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PGATournamentFieldApi.getField']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Returns the tournament field for the current week (Sunday 2AM EST to Sunday 2AM EST). Returns 404 if no tournament is scheduled this week. Returns 200 with player_tiers: null if tournament exists but field data is not yet available. 
         * @summary Fetches the player field for the current week\'s tournament
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWeeklyField(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WeeklyPgaTournamentField>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWeeklyField(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PGATournamentFieldApi.getWeeklyField']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * PGATournamentFieldApi - factory interface
 * @export
 */
export const PGATournamentFieldApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PGATournamentFieldApiFp(configuration)
    return {
        /**
         * Fetches the tiered player field for a given PGA Tournament
         * @summary Fetches the player field for a given PGA Tournament
         * @param {PGATournamentFieldApiGetFieldRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getField(requestParameters: PGATournamentFieldApiGetFieldRequest, options?: RawAxiosRequestConfig): AxiosPromise<PgaTournamentField> {
            return localVarFp.getField(requestParameters.pgaTournamentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the tournament field for the current week (Sunday 2AM EST to Sunday 2AM EST). Returns 404 if no tournament is scheduled this week. Returns 200 with player_tiers: null if tournament exists but field data is not yet available. 
         * @summary Fetches the player field for the current week\'s tournament
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWeeklyField(options?: RawAxiosRequestConfig): AxiosPromise<WeeklyPgaTournamentField> {
            return localVarFp.getWeeklyField(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getField operation in PGATournamentFieldApi.
 * @export
 * @interface PGATournamentFieldApiGetFieldRequest
 */
export interface PGATournamentFieldApiGetFieldRequest {
    /**
     * The PGA Tournament ID
     * @type {string}
     * @memberof PGATournamentFieldApiGetField
     */
    readonly pgaTournamentId: string
}

/**
 * PGATournamentFieldApi - object-oriented interface
 * @export
 * @class PGATournamentFieldApi
 * @extends {BaseAPI}
 */
export class PGATournamentFieldApi extends BaseAPI {
    /**
     * Fetches the tiered player field for a given PGA Tournament
     * @summary Fetches the player field for a given PGA Tournament
     * @param {PGATournamentFieldApiGetFieldRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PGATournamentFieldApi
     */
    public getField(requestParameters: PGATournamentFieldApiGetFieldRequest, options?: RawAxiosRequestConfig) {
        return PGATournamentFieldApiFp(this.configuration).getField(requestParameters.pgaTournamentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the tournament field for the current week (Sunday 2AM EST to Sunday 2AM EST). Returns 404 if no tournament is scheduled this week. Returns 200 with player_tiers: null if tournament exists but field data is not yet available. 
     * @summary Fetches the player field for the current week\'s tournament
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PGATournamentFieldApi
     */
    public getWeeklyField(options?: RawAxiosRequestConfig) {
        return PGATournamentFieldApiFp(this.configuration).getWeeklyField(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PGATournamentPlayersApi - axios parameter creator
 * @export
 */
export const PGATournamentPlayersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns per-round scoring summaries derived from hole-by-hole data
         * @summary Gets round score summaries for a PGA tournament player
         * @param {string} pgaTournamentPlayerId The PGA Tournament Player ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPgaTournamentPlayerRounds: async (pgaTournamentPlayerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pgaTournamentPlayerId' is not null or undefined
            assertParamExists('getPgaTournamentPlayerRounds', 'pgaTournamentPlayerId', pgaTournamentPlayerId)
            const localVarPath = `/pga-tournament-players/{pgaTournamentPlayerId}/rounds`
                .replace(`{${"pgaTournamentPlayerId"}}`, encodeURIComponent(String(pgaTournamentPlayerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns hole-by-hole scorecard data for a given round
         * @summary Gets the scorecard for a PGA tournament player for a specific round
         * @param {string} pgaTournamentPlayerId The PGA Tournament Player ID
         * @param {number} round The round number (1-4)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPgaTournamentPlayerScorecard: async (pgaTournamentPlayerId: string, round: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pgaTournamentPlayerId' is not null or undefined
            assertParamExists('getPgaTournamentPlayerScorecard', 'pgaTournamentPlayerId', pgaTournamentPlayerId)
            // verify required parameter 'round' is not null or undefined
            assertParamExists('getPgaTournamentPlayerScorecard', 'round', round)
            const localVarPath = `/pga-tournament-players/{pgaTournamentPlayerId}/scorecard`
                .replace(`{${"pgaTournamentPlayerId"}}`, encodeURIComponent(String(pgaTournamentPlayerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (round !== undefined) {
                localVarQueryParameter['round'] = round;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists players for a given PGA Tournament
         * @summary Lists players for a given PGA Tournament
         * @param {string} pgaTournamentId The PGA Tournament ID
         * @param {ListPoolsPageParameter} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPgaTournamentPlayers: async (pgaTournamentId: string, page?: ListPoolsPageParameter, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pgaTournamentId' is not null or undefined
            assertParamExists('listPgaTournamentPlayers', 'pgaTournamentId', pgaTournamentId)
            const localVarPath = `/pga-tournaments/{pgaTournamentId}/players`
                .replace(`{${"pgaTournamentId"}}`, encodeURIComponent(String(pgaTournamentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PGATournamentPlayersApi - functional programming interface
 * @export
 */
export const PGATournamentPlayersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PGATournamentPlayersApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns per-round scoring summaries derived from hole-by-hole data
         * @summary Gets round score summaries for a PGA tournament player
         * @param {string} pgaTournamentPlayerId The PGA Tournament Player ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPgaTournamentPlayerRounds(pgaTournamentPlayerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RoundSummary>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPgaTournamentPlayerRounds(pgaTournamentPlayerId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PGATournamentPlayersApi.getPgaTournamentPlayerRounds']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Returns hole-by-hole scorecard data for a given round
         * @summary Gets the scorecard for a PGA tournament player for a specific round
         * @param {string} pgaTournamentPlayerId The PGA Tournament Player ID
         * @param {number} round The round number (1-4)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPgaTournamentPlayerScorecard(pgaTournamentPlayerId: string, round: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Scorecard>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPgaTournamentPlayerScorecard(pgaTournamentPlayerId, round, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PGATournamentPlayersApi.getPgaTournamentPlayerScorecard']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Lists players for a given PGA Tournament
         * @summary Lists players for a given PGA Tournament
         * @param {string} pgaTournamentId The PGA Tournament ID
         * @param {ListPoolsPageParameter} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPgaTournamentPlayers(pgaTournamentId: string, page?: ListPoolsPageParameter, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListPgaTournamentPlayers200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPgaTournamentPlayers(pgaTournamentId, page, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PGATournamentPlayersApi.listPgaTournamentPlayers']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * PGATournamentPlayersApi - factory interface
 * @export
 */
export const PGATournamentPlayersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PGATournamentPlayersApiFp(configuration)
    return {
        /**
         * Returns per-round scoring summaries derived from hole-by-hole data
         * @summary Gets round score summaries for a PGA tournament player
         * @param {PGATournamentPlayersApiGetPgaTournamentPlayerRoundsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPgaTournamentPlayerRounds(requestParameters: PGATournamentPlayersApiGetPgaTournamentPlayerRoundsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<RoundSummary>> {
            return localVarFp.getPgaTournamentPlayerRounds(requestParameters.pgaTournamentPlayerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns hole-by-hole scorecard data for a given round
         * @summary Gets the scorecard for a PGA tournament player for a specific round
         * @param {PGATournamentPlayersApiGetPgaTournamentPlayerScorecardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPgaTournamentPlayerScorecard(requestParameters: PGATournamentPlayersApiGetPgaTournamentPlayerScorecardRequest, options?: RawAxiosRequestConfig): AxiosPromise<Scorecard> {
            return localVarFp.getPgaTournamentPlayerScorecard(requestParameters.pgaTournamentPlayerId, requestParameters.round, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists players for a given PGA Tournament
         * @summary Lists players for a given PGA Tournament
         * @param {PGATournamentPlayersApiListPgaTournamentPlayersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPgaTournamentPlayers(requestParameters: PGATournamentPlayersApiListPgaTournamentPlayersRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListPgaTournamentPlayers200Response> {
            return localVarFp.listPgaTournamentPlayers(requestParameters.pgaTournamentId, requestParameters.page, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getPgaTournamentPlayerRounds operation in PGATournamentPlayersApi.
 * @export
 * @interface PGATournamentPlayersApiGetPgaTournamentPlayerRoundsRequest
 */
export interface PGATournamentPlayersApiGetPgaTournamentPlayerRoundsRequest {
    /**
     * The PGA Tournament Player ID
     * @type {string}
     * @memberof PGATournamentPlayersApiGetPgaTournamentPlayerRounds
     */
    readonly pgaTournamentPlayerId: string
}

/**
 * Request parameters for getPgaTournamentPlayerScorecard operation in PGATournamentPlayersApi.
 * @export
 * @interface PGATournamentPlayersApiGetPgaTournamentPlayerScorecardRequest
 */
export interface PGATournamentPlayersApiGetPgaTournamentPlayerScorecardRequest {
    /**
     * The PGA Tournament Player ID
     * @type {string}
     * @memberof PGATournamentPlayersApiGetPgaTournamentPlayerScorecard
     */
    readonly pgaTournamentPlayerId: string

    /**
     * The round number (1-4)
     * @type {number}
     * @memberof PGATournamentPlayersApiGetPgaTournamentPlayerScorecard
     */
    readonly round: number
}

/**
 * Request parameters for listPgaTournamentPlayers operation in PGATournamentPlayersApi.
 * @export
 * @interface PGATournamentPlayersApiListPgaTournamentPlayersRequest
 */
export interface PGATournamentPlayersApiListPgaTournamentPlayersRequest {
    /**
     * The PGA Tournament ID
     * @type {string}
     * @memberof PGATournamentPlayersApiListPgaTournamentPlayers
     */
    readonly pgaTournamentId: string

    /**
     * 
     * @type {ListPoolsPageParameter}
     * @memberof PGATournamentPlayersApiListPgaTournamentPlayers
     */
    readonly page?: ListPoolsPageParameter
}

/**
 * PGATournamentPlayersApi - object-oriented interface
 * @export
 * @class PGATournamentPlayersApi
 * @extends {BaseAPI}
 */
export class PGATournamentPlayersApi extends BaseAPI {
    /**
     * Returns per-round scoring summaries derived from hole-by-hole data
     * @summary Gets round score summaries for a PGA tournament player
     * @param {PGATournamentPlayersApiGetPgaTournamentPlayerRoundsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PGATournamentPlayersApi
     */
    public getPgaTournamentPlayerRounds(requestParameters: PGATournamentPlayersApiGetPgaTournamentPlayerRoundsRequest, options?: RawAxiosRequestConfig) {
        return PGATournamentPlayersApiFp(this.configuration).getPgaTournamentPlayerRounds(requestParameters.pgaTournamentPlayerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns hole-by-hole scorecard data for a given round
     * @summary Gets the scorecard for a PGA tournament player for a specific round
     * @param {PGATournamentPlayersApiGetPgaTournamentPlayerScorecardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PGATournamentPlayersApi
     */
    public getPgaTournamentPlayerScorecard(requestParameters: PGATournamentPlayersApiGetPgaTournamentPlayerScorecardRequest, options?: RawAxiosRequestConfig) {
        return PGATournamentPlayersApiFp(this.configuration).getPgaTournamentPlayerScorecard(requestParameters.pgaTournamentPlayerId, requestParameters.round, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists players for a given PGA Tournament
     * @summary Lists players for a given PGA Tournament
     * @param {PGATournamentPlayersApiListPgaTournamentPlayersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PGATournamentPlayersApi
     */
    public listPgaTournamentPlayers(requestParameters: PGATournamentPlayersApiListPgaTournamentPlayersRequest, options?: RawAxiosRequestConfig) {
        return PGATournamentPlayersApiFp(this.configuration).listPgaTournamentPlayers(requestParameters.pgaTournamentId, requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PGATournamentsApi - axios parameter creator
 * @export
 */
export const PGATournamentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns the tournament field for the current week (Sunday 2AM EST to Sunday 2AM EST). Returns 404 if no tournament is scheduled this week. Returns 200 with player_tiers: null if tournament exists but field data is not yet available. 
         * @summary Fetches the player field for the current week\'s tournament
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWeeklyField: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/pga-tournaments/weekly-field`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists PGA Tournaments
         * @summary Lists PGA Tournaments
         * @param {ListPoolsPageParameter} [page] 
         * @param {ListPoolTournamentsFilterParameter} [filter] Filters a collection of PGA Tournaments.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPgaTournaments: async (page?: ListPoolsPageParameter, filter?: ListPoolTournamentsFilterParameter, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/pga-tournaments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PGATournamentsApi - functional programming interface
 * @export
 */
export const PGATournamentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PGATournamentsApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns the tournament field for the current week (Sunday 2AM EST to Sunday 2AM EST). Returns 404 if no tournament is scheduled this week. Returns 200 with player_tiers: null if tournament exists but field data is not yet available. 
         * @summary Fetches the player field for the current week\'s tournament
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWeeklyField(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WeeklyPgaTournamentField>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWeeklyField(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PGATournamentsApi.getWeeklyField']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Lists PGA Tournaments
         * @summary Lists PGA Tournaments
         * @param {ListPoolsPageParameter} [page] 
         * @param {ListPoolTournamentsFilterParameter} [filter] Filters a collection of PGA Tournaments.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPgaTournaments(page?: ListPoolsPageParameter, filter?: ListPoolTournamentsFilterParameter, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListPgaTournaments200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPgaTournaments(page, filter, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PGATournamentsApi.listPgaTournaments']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * PGATournamentsApi - factory interface
 * @export
 */
export const PGATournamentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PGATournamentsApiFp(configuration)
    return {
        /**
         * Returns the tournament field for the current week (Sunday 2AM EST to Sunday 2AM EST). Returns 404 if no tournament is scheduled this week. Returns 200 with player_tiers: null if tournament exists but field data is not yet available. 
         * @summary Fetches the player field for the current week\'s tournament
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWeeklyField(options?: RawAxiosRequestConfig): AxiosPromise<WeeklyPgaTournamentField> {
            return localVarFp.getWeeklyField(options).then((request) => request(axios, basePath));
        },
        /**
         * Lists PGA Tournaments
         * @summary Lists PGA Tournaments
         * @param {PGATournamentsApiListPgaTournamentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPgaTournaments(requestParameters: PGATournamentsApiListPgaTournamentsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListPgaTournaments200Response> {
            return localVarFp.listPgaTournaments(requestParameters.page, requestParameters.filter, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for listPgaTournaments operation in PGATournamentsApi.
 * @export
 * @interface PGATournamentsApiListPgaTournamentsRequest
 */
export interface PGATournamentsApiListPgaTournamentsRequest {
    /**
     * 
     * @type {ListPoolsPageParameter}
     * @memberof PGATournamentsApiListPgaTournaments
     */
    readonly page?: ListPoolsPageParameter

    /**
     * Filters a collection of PGA Tournaments.
     * @type {ListPoolTournamentsFilterParameter}
     * @memberof PGATournamentsApiListPgaTournaments
     */
    readonly filter?: ListPoolTournamentsFilterParameter
}

/**
 * PGATournamentsApi - object-oriented interface
 * @export
 * @class PGATournamentsApi
 * @extends {BaseAPI}
 */
export class PGATournamentsApi extends BaseAPI {
    /**
     * Returns the tournament field for the current week (Sunday 2AM EST to Sunday 2AM EST). Returns 404 if no tournament is scheduled this week. Returns 200 with player_tiers: null if tournament exists but field data is not yet available. 
     * @summary Fetches the player field for the current week\'s tournament
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PGATournamentsApi
     */
    public getWeeklyField(options?: RawAxiosRequestConfig) {
        return PGATournamentsApiFp(this.configuration).getWeeklyField(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists PGA Tournaments
     * @summary Lists PGA Tournaments
     * @param {PGATournamentsApiListPgaTournamentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PGATournamentsApi
     */
    public listPgaTournaments(requestParameters: PGATournamentsApiListPgaTournamentsRequest = {}, options?: RawAxiosRequestConfig) {
        return PGATournamentsApiFp(this.configuration).listPgaTournaments(requestParameters.page, requestParameters.filter, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PoolTournamentFieldApi - axios parameter creator
 * @export
 */
export const PoolTournamentFieldApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Fetches the tiered player field for a given pool tournament
         * @summary Fetches the player field for a given pool tournament
         * @param {string} poolId Pool ID
         * @param {string} poolTournamentId Pool Tournament ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPoolTournamentField: async (poolId: string, poolTournamentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'poolId' is not null or undefined
            assertParamExists('getPoolTournamentField', 'poolId', poolId)
            // verify required parameter 'poolTournamentId' is not null or undefined
            assertParamExists('getPoolTournamentField', 'poolTournamentId', poolTournamentId)
            const localVarPath = `/pools/{poolId}/tournaments/{poolTournamentId}/field`
                .replace(`{${"poolId"}}`, encodeURIComponent(String(poolId)))
                .replace(`{${"poolTournamentId"}}`, encodeURIComponent(String(poolTournamentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resolves the current week\'s PGA tournament and returns the tiered player field for the corresponding pool tournament
         * @summary Fetches the player field for the current week\'s pool tournament
         * @param {string} poolId Pool ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWeeklyPoolTournamentField: async (poolId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'poolId' is not null or undefined
            assertParamExists('getWeeklyPoolTournamentField', 'poolId', poolId)
            const localVarPath = `/pools/{poolId}/weekly-field`
                .replace(`{${"poolId"}}`, encodeURIComponent(String(poolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PoolTournamentFieldApi - functional programming interface
 * @export
 */
export const PoolTournamentFieldApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PoolTournamentFieldApiAxiosParamCreator(configuration)
    return {
        /**
         * Fetches the tiered player field for a given pool tournament
         * @summary Fetches the player field for a given pool tournament
         * @param {string} poolId Pool ID
         * @param {string} poolTournamentId Pool Tournament ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPoolTournamentField(poolId: string, poolTournamentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PoolTournamentField>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPoolTournamentField(poolId, poolTournamentId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PoolTournamentFieldApi.getPoolTournamentField']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Resolves the current week\'s PGA tournament and returns the tiered player field for the corresponding pool tournament
         * @summary Fetches the player field for the current week\'s pool tournament
         * @param {string} poolId Pool ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWeeklyPoolTournamentField(poolId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PoolTournamentField>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWeeklyPoolTournamentField(poolId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PoolTournamentFieldApi.getWeeklyPoolTournamentField']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * PoolTournamentFieldApi - factory interface
 * @export
 */
export const PoolTournamentFieldApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PoolTournamentFieldApiFp(configuration)
    return {
        /**
         * Fetches the tiered player field for a given pool tournament
         * @summary Fetches the player field for a given pool tournament
         * @param {PoolTournamentFieldApiGetPoolTournamentFieldRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPoolTournamentField(requestParameters: PoolTournamentFieldApiGetPoolTournamentFieldRequest, options?: RawAxiosRequestConfig): AxiosPromise<PoolTournamentField> {
            return localVarFp.getPoolTournamentField(requestParameters.poolId, requestParameters.poolTournamentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Resolves the current week\'s PGA tournament and returns the tiered player field for the corresponding pool tournament
         * @summary Fetches the player field for the current week\'s pool tournament
         * @param {PoolTournamentFieldApiGetWeeklyPoolTournamentFieldRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWeeklyPoolTournamentField(requestParameters: PoolTournamentFieldApiGetWeeklyPoolTournamentFieldRequest, options?: RawAxiosRequestConfig): AxiosPromise<PoolTournamentField> {
            return localVarFp.getWeeklyPoolTournamentField(requestParameters.poolId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getPoolTournamentField operation in PoolTournamentFieldApi.
 * @export
 * @interface PoolTournamentFieldApiGetPoolTournamentFieldRequest
 */
export interface PoolTournamentFieldApiGetPoolTournamentFieldRequest {
    /**
     * Pool ID
     * @type {string}
     * @memberof PoolTournamentFieldApiGetPoolTournamentField
     */
    readonly poolId: string

    /**
     * Pool Tournament ID
     * @type {string}
     * @memberof PoolTournamentFieldApiGetPoolTournamentField
     */
    readonly poolTournamentId: string
}

/**
 * Request parameters for getWeeklyPoolTournamentField operation in PoolTournamentFieldApi.
 * @export
 * @interface PoolTournamentFieldApiGetWeeklyPoolTournamentFieldRequest
 */
export interface PoolTournamentFieldApiGetWeeklyPoolTournamentFieldRequest {
    /**
     * Pool ID
     * @type {string}
     * @memberof PoolTournamentFieldApiGetWeeklyPoolTournamentField
     */
    readonly poolId: string
}

/**
 * PoolTournamentFieldApi - object-oriented interface
 * @export
 * @class PoolTournamentFieldApi
 * @extends {BaseAPI}
 */
export class PoolTournamentFieldApi extends BaseAPI {
    /**
     * Fetches the tiered player field for a given pool tournament
     * @summary Fetches the player field for a given pool tournament
     * @param {PoolTournamentFieldApiGetPoolTournamentFieldRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoolTournamentFieldApi
     */
    public getPoolTournamentField(requestParameters: PoolTournamentFieldApiGetPoolTournamentFieldRequest, options?: RawAxiosRequestConfig) {
        return PoolTournamentFieldApiFp(this.configuration).getPoolTournamentField(requestParameters.poolId, requestParameters.poolTournamentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Resolves the current week\'s PGA tournament and returns the tiered player field for the corresponding pool tournament
     * @summary Fetches the player field for the current week\'s pool tournament
     * @param {PoolTournamentFieldApiGetWeeklyPoolTournamentFieldRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoolTournamentFieldApi
     */
    public getWeeklyPoolTournamentField(requestParameters: PoolTournamentFieldApiGetWeeklyPoolTournamentFieldRequest, options?: RawAxiosRequestConfig) {
        return PoolTournamentFieldApiFp(this.configuration).getWeeklyPoolTournamentField(requestParameters.poolId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PoolTournamentPlayersApi - axios parameter creator
 * @export
 */
export const PoolTournamentPlayersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Lists players for a given pool tournament
         * @summary Lists players for a given pool tournament
         * @param {string} poolId Pool ID
         * @param {string} poolTournamentId Pool Tournament ID
         * @param {ListPoolsPageParameter} [page] 
         * @param {ListPoolTournamentPlayersFilterParameter} [filter] Filters a collection of Pool Tournament Players.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPoolTournamentPlayers: async (poolId: string, poolTournamentId: string, page?: ListPoolsPageParameter, filter?: ListPoolTournamentPlayersFilterParameter, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'poolId' is not null or undefined
            assertParamExists('listPoolTournamentPlayers', 'poolId', poolId)
            // verify required parameter 'poolTournamentId' is not null or undefined
            assertParamExists('listPoolTournamentPlayers', 'poolTournamentId', poolTournamentId)
            const localVarPath = `/pools/{poolId}/tournaments/{poolTournamentId}/players`
                .replace(`{${"poolId"}}`, encodeURIComponent(String(poolId)))
                .replace(`{${"poolTournamentId"}}`, encodeURIComponent(String(poolTournamentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PoolTournamentPlayersApi - functional programming interface
 * @export
 */
export const PoolTournamentPlayersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PoolTournamentPlayersApiAxiosParamCreator(configuration)
    return {
        /**
         * Lists players for a given pool tournament
         * @summary Lists players for a given pool tournament
         * @param {string} poolId Pool ID
         * @param {string} poolTournamentId Pool Tournament ID
         * @param {ListPoolsPageParameter} [page] 
         * @param {ListPoolTournamentPlayersFilterParameter} [filter] Filters a collection of Pool Tournament Players.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPoolTournamentPlayers(poolId: string, poolTournamentId: string, page?: ListPoolsPageParameter, filter?: ListPoolTournamentPlayersFilterParameter, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListPoolTournamentPlayers200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPoolTournamentPlayers(poolId, poolTournamentId, page, filter, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PoolTournamentPlayersApi.listPoolTournamentPlayers']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * PoolTournamentPlayersApi - factory interface
 * @export
 */
export const PoolTournamentPlayersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PoolTournamentPlayersApiFp(configuration)
    return {
        /**
         * Lists players for a given pool tournament
         * @summary Lists players for a given pool tournament
         * @param {PoolTournamentPlayersApiListPoolTournamentPlayersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPoolTournamentPlayers(requestParameters: PoolTournamentPlayersApiListPoolTournamentPlayersRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListPoolTournamentPlayers200Response> {
            return localVarFp.listPoolTournamentPlayers(requestParameters.poolId, requestParameters.poolTournamentId, requestParameters.page, requestParameters.filter, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for listPoolTournamentPlayers operation in PoolTournamentPlayersApi.
 * @export
 * @interface PoolTournamentPlayersApiListPoolTournamentPlayersRequest
 */
export interface PoolTournamentPlayersApiListPoolTournamentPlayersRequest {
    /**
     * Pool ID
     * @type {string}
     * @memberof PoolTournamentPlayersApiListPoolTournamentPlayers
     */
    readonly poolId: string

    /**
     * Pool Tournament ID
     * @type {string}
     * @memberof PoolTournamentPlayersApiListPoolTournamentPlayers
     */
    readonly poolTournamentId: string

    /**
     * 
     * @type {ListPoolsPageParameter}
     * @memberof PoolTournamentPlayersApiListPoolTournamentPlayers
     */
    readonly page?: ListPoolsPageParameter

    /**
     * Filters a collection of Pool Tournament Players.
     * @type {ListPoolTournamentPlayersFilterParameter}
     * @memberof PoolTournamentPlayersApiListPoolTournamentPlayers
     */
    readonly filter?: ListPoolTournamentPlayersFilterParameter
}

/**
 * PoolTournamentPlayersApi - object-oriented interface
 * @export
 * @class PoolTournamentPlayersApi
 * @extends {BaseAPI}
 */
export class PoolTournamentPlayersApi extends BaseAPI {
    /**
     * Lists players for a given pool tournament
     * @summary Lists players for a given pool tournament
     * @param {PoolTournamentPlayersApiListPoolTournamentPlayersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoolTournamentPlayersApi
     */
    public listPoolTournamentPlayers(requestParameters: PoolTournamentPlayersApiListPoolTournamentPlayersRequest, options?: RawAxiosRequestConfig) {
        return PoolTournamentPlayersApiFp(this.configuration).listPoolTournamentPlayers(requestParameters.poolId, requestParameters.poolTournamentId, requestParameters.page, requestParameters.filter, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PoolTournamentUsersApi - axios parameter creator
 * @export
 */
export const PoolTournamentUsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Lists users for a given pool tournament
         * @summary Lists users for a given pool tournament
         * @param {string} poolId Pool ID
         * @param {string} poolTournamentId Pool Tournament ID
         * @param {ListPoolsPageParameter} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPoolTournamentUsers: async (poolId: string, poolTournamentId: string, page?: ListPoolsPageParameter, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'poolId' is not null or undefined
            assertParamExists('listPoolTournamentUsers', 'poolId', poolId)
            // verify required parameter 'poolTournamentId' is not null or undefined
            assertParamExists('listPoolTournamentUsers', 'poolTournamentId', poolTournamentId)
            const localVarPath = `/pools/{poolId}/tournaments/{poolTournamentId}/users`
                .replace(`{${"poolId"}}`, encodeURIComponent(String(poolId)))
                .replace(`{${"poolTournamentId"}}`, encodeURIComponent(String(poolTournamentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PoolTournamentUsersApi - functional programming interface
 * @export
 */
export const PoolTournamentUsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PoolTournamentUsersApiAxiosParamCreator(configuration)
    return {
        /**
         * Lists users for a given pool tournament
         * @summary Lists users for a given pool tournament
         * @param {string} poolId Pool ID
         * @param {string} poolTournamentId Pool Tournament ID
         * @param {ListPoolsPageParameter} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPoolTournamentUsers(poolId: string, poolTournamentId: string, page?: ListPoolsPageParameter, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListPoolTournamentUsers200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPoolTournamentUsers(poolId, poolTournamentId, page, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PoolTournamentUsersApi.listPoolTournamentUsers']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * PoolTournamentUsersApi - factory interface
 * @export
 */
export const PoolTournamentUsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PoolTournamentUsersApiFp(configuration)
    return {
        /**
         * Lists users for a given pool tournament
         * @summary Lists users for a given pool tournament
         * @param {PoolTournamentUsersApiListPoolTournamentUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPoolTournamentUsers(requestParameters: PoolTournamentUsersApiListPoolTournamentUsersRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListPoolTournamentUsers200Response> {
            return localVarFp.listPoolTournamentUsers(requestParameters.poolId, requestParameters.poolTournamentId, requestParameters.page, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for listPoolTournamentUsers operation in PoolTournamentUsersApi.
 * @export
 * @interface PoolTournamentUsersApiListPoolTournamentUsersRequest
 */
export interface PoolTournamentUsersApiListPoolTournamentUsersRequest {
    /**
     * Pool ID
     * @type {string}
     * @memberof PoolTournamentUsersApiListPoolTournamentUsers
     */
    readonly poolId: string

    /**
     * Pool Tournament ID
     * @type {string}
     * @memberof PoolTournamentUsersApiListPoolTournamentUsers
     */
    readonly poolTournamentId: string

    /**
     * 
     * @type {ListPoolsPageParameter}
     * @memberof PoolTournamentUsersApiListPoolTournamentUsers
     */
    readonly page?: ListPoolsPageParameter
}

/**
 * PoolTournamentUsersApi - object-oriented interface
 * @export
 * @class PoolTournamentUsersApi
 * @extends {BaseAPI}
 */
export class PoolTournamentUsersApi extends BaseAPI {
    /**
     * Lists users for a given pool tournament
     * @summary Lists users for a given pool tournament
     * @param {PoolTournamentUsersApiListPoolTournamentUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoolTournamentUsersApi
     */
    public listPoolTournamentUsers(requestParameters: PoolTournamentUsersApiListPoolTournamentUsersRequest, options?: RawAxiosRequestConfig) {
        return PoolTournamentUsersApiFp(this.configuration).listPoolTournamentUsers(requestParameters.poolId, requestParameters.poolTournamentId, requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PoolTournamentsApi - axios parameter creator
 * @export
 */
export const PoolTournamentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Fetches a pool tournament by ID
         * @summary Fetches a pool tournament by ID
         * @param {string} poolId Pool ID
         * @param {string} poolTournamentId Pool Tournament ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPoolTournament: async (poolId: string, poolTournamentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'poolId' is not null or undefined
            assertParamExists('getPoolTournament', 'poolId', poolId)
            // verify required parameter 'poolTournamentId' is not null or undefined
            assertParamExists('getPoolTournament', 'poolTournamentId', poolTournamentId)
            const localVarPath = `/pools/{poolId}/tournaments/{poolTournamentId}`
                .replace(`{${"poolId"}}`, encodeURIComponent(String(poolId)))
                .replace(`{${"poolTournamentId"}}`, encodeURIComponent(String(poolTournamentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all pool tournaments for a pool
         * @summary Lists pool tournaments
         * @param {string} poolId Pool ID
         * @param {ListPoolsPageParameter} [page] 
         * @param {ListPoolTournamentsFilterParameter} [filter] Filters a collection of PGA Tournaments.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPoolTournaments: async (poolId: string, page?: ListPoolsPageParameter, filter?: ListPoolTournamentsFilterParameter, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'poolId' is not null or undefined
            assertParamExists('listPoolTournaments', 'poolId', poolId)
            const localVarPath = `/pools/{poolId}/tournaments`
                .replace(`{${"poolId"}}`, encodeURIComponent(String(poolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PoolTournamentsApi - functional programming interface
 * @export
 */
export const PoolTournamentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PoolTournamentsApiAxiosParamCreator(configuration)
    return {
        /**
         * Fetches a pool tournament by ID
         * @summary Fetches a pool tournament by ID
         * @param {string} poolId Pool ID
         * @param {string} poolTournamentId Pool Tournament ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPoolTournament(poolId: string, poolTournamentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PoolTournament>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPoolTournament(poolId, poolTournamentId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PoolTournamentsApi.getPoolTournament']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Returns all pool tournaments for a pool
         * @summary Lists pool tournaments
         * @param {string} poolId Pool ID
         * @param {ListPoolsPageParameter} [page] 
         * @param {ListPoolTournamentsFilterParameter} [filter] Filters a collection of PGA Tournaments.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPoolTournaments(poolId: string, page?: ListPoolsPageParameter, filter?: ListPoolTournamentsFilterParameter, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListPoolTournaments200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPoolTournaments(poolId, page, filter, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PoolTournamentsApi.listPoolTournaments']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * PoolTournamentsApi - factory interface
 * @export
 */
export const PoolTournamentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PoolTournamentsApiFp(configuration)
    return {
        /**
         * Fetches a pool tournament by ID
         * @summary Fetches a pool tournament by ID
         * @param {PoolTournamentsApiGetPoolTournamentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPoolTournament(requestParameters: PoolTournamentsApiGetPoolTournamentRequest, options?: RawAxiosRequestConfig): AxiosPromise<PoolTournament> {
            return localVarFp.getPoolTournament(requestParameters.poolId, requestParameters.poolTournamentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all pool tournaments for a pool
         * @summary Lists pool tournaments
         * @param {PoolTournamentsApiListPoolTournamentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPoolTournaments(requestParameters: PoolTournamentsApiListPoolTournamentsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListPoolTournaments200Response> {
            return localVarFp.listPoolTournaments(requestParameters.poolId, requestParameters.page, requestParameters.filter, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getPoolTournament operation in PoolTournamentsApi.
 * @export
 * @interface PoolTournamentsApiGetPoolTournamentRequest
 */
export interface PoolTournamentsApiGetPoolTournamentRequest {
    /**
     * Pool ID
     * @type {string}
     * @memberof PoolTournamentsApiGetPoolTournament
     */
    readonly poolId: string

    /**
     * Pool Tournament ID
     * @type {string}
     * @memberof PoolTournamentsApiGetPoolTournament
     */
    readonly poolTournamentId: string
}

/**
 * Request parameters for listPoolTournaments operation in PoolTournamentsApi.
 * @export
 * @interface PoolTournamentsApiListPoolTournamentsRequest
 */
export interface PoolTournamentsApiListPoolTournamentsRequest {
    /**
     * Pool ID
     * @type {string}
     * @memberof PoolTournamentsApiListPoolTournaments
     */
    readonly poolId: string

    /**
     * 
     * @type {ListPoolsPageParameter}
     * @memberof PoolTournamentsApiListPoolTournaments
     */
    readonly page?: ListPoolsPageParameter

    /**
     * Filters a collection of PGA Tournaments.
     * @type {ListPoolTournamentsFilterParameter}
     * @memberof PoolTournamentsApiListPoolTournaments
     */
    readonly filter?: ListPoolTournamentsFilterParameter
}

/**
 * PoolTournamentsApi - object-oriented interface
 * @export
 * @class PoolTournamentsApi
 * @extends {BaseAPI}
 */
export class PoolTournamentsApi extends BaseAPI {
    /**
     * Fetches a pool tournament by ID
     * @summary Fetches a pool tournament by ID
     * @param {PoolTournamentsApiGetPoolTournamentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoolTournamentsApi
     */
    public getPoolTournament(requestParameters: PoolTournamentsApiGetPoolTournamentRequest, options?: RawAxiosRequestConfig) {
        return PoolTournamentsApiFp(this.configuration).getPoolTournament(requestParameters.poolId, requestParameters.poolTournamentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all pool tournaments for a pool
     * @summary Lists pool tournaments
     * @param {PoolTournamentsApiListPoolTournamentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoolTournamentsApi
     */
    public listPoolTournaments(requestParameters: PoolTournamentsApiListPoolTournamentsRequest, options?: RawAxiosRequestConfig) {
        return PoolTournamentsApiFp(this.configuration).listPoolTournaments(requestParameters.poolId, requestParameters.page, requestParameters.filter, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PoolUsersApi - axios parameter creator
 * @export
 */
export const PoolUsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Lists users for a given pool
         * @summary Lists users for a given pool
         * @param {string} poolId Pool ID
         * @param {ListPoolsPageParameter} [page] 
         * @param {ListPoolUsersFilterParameter} [filter] Filters a collection of Pool Users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPoolUsers: async (poolId: string, page?: ListPoolsPageParameter, filter?: ListPoolUsersFilterParameter, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'poolId' is not null or undefined
            assertParamExists('listPoolUsers', 'poolId', poolId)
            const localVarPath = `/pools/{poolId}/users`
                .replace(`{${"poolId"}}`, encodeURIComponent(String(poolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PoolUsersApi - functional programming interface
 * @export
 */
export const PoolUsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PoolUsersApiAxiosParamCreator(configuration)
    return {
        /**
         * Lists users for a given pool
         * @summary Lists users for a given pool
         * @param {string} poolId Pool ID
         * @param {ListPoolsPageParameter} [page] 
         * @param {ListPoolUsersFilterParameter} [filter] Filters a collection of Pool Users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPoolUsers(poolId: string, page?: ListPoolsPageParameter, filter?: ListPoolUsersFilterParameter, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListPoolUsers200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPoolUsers(poolId, page, filter, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PoolUsersApi.listPoolUsers']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * PoolUsersApi - factory interface
 * @export
 */
export const PoolUsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PoolUsersApiFp(configuration)
    return {
        /**
         * Lists users for a given pool
         * @summary Lists users for a given pool
         * @param {PoolUsersApiListPoolUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPoolUsers(requestParameters: PoolUsersApiListPoolUsersRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListPoolUsers200Response> {
            return localVarFp.listPoolUsers(requestParameters.poolId, requestParameters.page, requestParameters.filter, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for listPoolUsers operation in PoolUsersApi.
 * @export
 * @interface PoolUsersApiListPoolUsersRequest
 */
export interface PoolUsersApiListPoolUsersRequest {
    /**
     * Pool ID
     * @type {string}
     * @memberof PoolUsersApiListPoolUsers
     */
    readonly poolId: string

    /**
     * 
     * @type {ListPoolsPageParameter}
     * @memberof PoolUsersApiListPoolUsers
     */
    readonly page?: ListPoolsPageParameter

    /**
     * Filters a collection of Pool Users.
     * @type {ListPoolUsersFilterParameter}
     * @memberof PoolUsersApiListPoolUsers
     */
    readonly filter?: ListPoolUsersFilterParameter
}

/**
 * PoolUsersApi - object-oriented interface
 * @export
 * @class PoolUsersApi
 * @extends {BaseAPI}
 */
export class PoolUsersApi extends BaseAPI {
    /**
     * Lists users for a given pool
     * @summary Lists users for a given pool
     * @param {PoolUsersApiListPoolUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoolUsersApi
     */
    public listPoolUsers(requestParameters: PoolUsersApiListPoolUsersRequest, options?: RawAxiosRequestConfig) {
        return PoolUsersApiFp(this.configuration).listPoolUsers(requestParameters.poolId, requestParameters.page, requestParameters.filter, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PoolsApi - axios parameter creator
 * @export
 */
export const PoolsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Fetches a pool by ID
         * @summary Fetches a pool by ID
         * @param {string} poolId Pool ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPool: async (poolId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'poolId' is not null or undefined
            assertParamExists('getPool', 'poolId', poolId)
            const localVarPath = `/pools/{poolId}`
                .replace(`{${"poolId"}}`, encodeURIComponent(String(poolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists Pools
         * @summary Lists Pools
         * @param {ListPoolsPageParameter} [page] 
         * @param {ListPoolsFilterParameter} [filter] Filters a collection of Pools.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPools: async (page?: ListPoolsPageParameter, filter?: ListPoolsFilterParameter, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/pools`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PoolsApi - functional programming interface
 * @export
 */
export const PoolsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PoolsApiAxiosParamCreator(configuration)
    return {
        /**
         * Fetches a pool by ID
         * @summary Fetches a pool by ID
         * @param {string} poolId Pool ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPool(poolId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Pool>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPool(poolId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PoolsApi.getPool']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Lists Pools
         * @summary Lists Pools
         * @param {ListPoolsPageParameter} [page] 
         * @param {ListPoolsFilterParameter} [filter] Filters a collection of Pools.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPools(page?: ListPoolsPageParameter, filter?: ListPoolsFilterParameter, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListPools200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPools(page, filter, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PoolsApi.listPools']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * PoolsApi - factory interface
 * @export
 */
export const PoolsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PoolsApiFp(configuration)
    return {
        /**
         * Fetches a pool by ID
         * @summary Fetches a pool by ID
         * @param {PoolsApiGetPoolRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPool(requestParameters: PoolsApiGetPoolRequest, options?: RawAxiosRequestConfig): AxiosPromise<Pool> {
            return localVarFp.getPool(requestParameters.poolId, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists Pools
         * @summary Lists Pools
         * @param {PoolsApiListPoolsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPools(requestParameters: PoolsApiListPoolsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListPools200Response> {
            return localVarFp.listPools(requestParameters.page, requestParameters.filter, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getPool operation in PoolsApi.
 * @export
 * @interface PoolsApiGetPoolRequest
 */
export interface PoolsApiGetPoolRequest {
    /**
     * Pool ID
     * @type {string}
     * @memberof PoolsApiGetPool
     */
    readonly poolId: string
}

/**
 * Request parameters for listPools operation in PoolsApi.
 * @export
 * @interface PoolsApiListPoolsRequest
 */
export interface PoolsApiListPoolsRequest {
    /**
     * 
     * @type {ListPoolsPageParameter}
     * @memberof PoolsApiListPools
     */
    readonly page?: ListPoolsPageParameter

    /**
     * Filters a collection of Pools.
     * @type {ListPoolsFilterParameter}
     * @memberof PoolsApiListPools
     */
    readonly filter?: ListPoolsFilterParameter
}

/**
 * PoolsApi - object-oriented interface
 * @export
 * @class PoolsApi
 * @extends {BaseAPI}
 */
export class PoolsApi extends BaseAPI {
    /**
     * Fetches a pool by ID
     * @summary Fetches a pool by ID
     * @param {PoolsApiGetPoolRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoolsApi
     */
    public getPool(requestParameters: PoolsApiGetPoolRequest, options?: RawAxiosRequestConfig) {
        return PoolsApiFp(this.configuration).getPool(requestParameters.poolId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists Pools
     * @summary Lists Pools
     * @param {PoolsApiListPoolsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoolsApi
     */
    public listPools(requestParameters: PoolsApiListPoolsRequest = {}, options?: RawAxiosRequestConfig) {
        return PoolsApiFp(this.configuration).listPools(requestParameters.page, requestParameters.filter, options).then((request) => request(this.axios, this.basePath));
    }
}



